export class ValidationMessages {
  static getValidatorErrorMessage(validatorName: string, validatorValue?: any): string {
    const messages: Record<string, string> = {
      required: 'Required',
      invalidEmailAddress: 'Invalid email address',
      invalidFormatPassword: 'Invalid password, password must be at least 6 characters long, and contain a number',
      invalidCnfPassword: 'Those passwords didn\'t match. Try again',
      minlength: `Minimum length ${validatorValue?.requiredLength}`,
      invalidValidationEmailCode: `Invalid code, code must be a numeric type`,
      invalidPhoneNumber: 'Invalid phone number, phone number must start with +'
    };

    return messages[validatorName] || 'Invalid field';
  }
}
